export default {
  getBillList: {
    url: '/billList',
    method: 'post',
  },
  getBillDetail: {
    url: '/billDetail',
    method: 'post',
  },
  getBillLogList: {
    url: '/billLogList',
    method: 'post',
  },
  billExport: {
    url: '/billExport',
    method: 'post',
    responseType:'blob'
  },
  getSupDataStatistics: {
    url: '/data/statistics/getSupDataStatistics',
    method: 'post',
  },
  getCorDataStatistics: {
    url: '/data/statistics/getCorDataStatistics',
    method: 'post',
  },
  getSupplierInfoSelect: {
    url: '/supplierInfoSelect',
    method: 'post',
  },
  getBankList: {
    url: '/data/statistics/getBankList',
    method: 'get',
  }
};